import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProductSearchRequest } from 'src/app/models/product';
import { PrincipalService } from 'src/app/services/principal.service';
import { TherapeuticService } from 'src/app/services/therapeutic.service';
import { Therapeutic, TherapeuticType } from 'src/app/models/therapeutic';
import { Principal } from 'src/app/models/principal';

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.css']
})
export class SearchFilterComponent implements OnInit {
  principalDDSetting = {};
  public therapeuticClass1: Therapeutic[] = [];
  public therapeuticClass2: Therapeutic[] = [];
  public therapeuticClass3: Therapeutic[] = [];
  public therapeuticClass4: Therapeutic[] = [];
  public principals: Principal[] = [];

  @Input() productSearchRequest: ProductSearchRequest;
  @Input() principalSelected: string[] = [];
  @Input() principalLock: Principal;
  @Output() OnSeeAllClicked: EventEmitter<boolean> = new EventEmitter();
  @Output() OnFilterSearchChanged: EventEmitter<ProductSearchRequest> = new EventEmitter();

  constructor(
    private principalService: PrincipalService,
    private therapeuticService: TherapeuticService) { }

  ngOnInit() {
    this.getPrincipal();
    this.getTherapeutic(TherapeuticType.CLASS1);
    this.setupDDSetting();
  }

  setupDDSetting(): void {
    this.principalDDSetting = {
      singleSelection: false,
      idField: 'code',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }

  getPrincipal(): void {
    this.principalService.getPrincipal('', 1000, 0,
      data => {
        this.principals = data;
      },
      err => {
        console.log(err);
      });
  }

  getTherapeutic(type: TherapeuticType): void {
    this.therapeuticService.getTherapeuticClass(type,
      this.productSearchRequest.class1,
      this.productSearchRequest.class2,
      this.productSearchRequest.class3,
      (data) => {
        if (type === TherapeuticType.CLASS1) {
          this.therapeuticClass1 = data;
        } else if (type === TherapeuticType.CLASS2) {
          this.therapeuticClass2 = data;
        } else if (type === TherapeuticType.CLASS3) {
          this.therapeuticClass3 = data;
        } else if (type === TherapeuticType.CLASS4) {
          this.therapeuticClass4 = data;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  resetCategoryFilter(type: TherapeuticType): void {
    if (type === 1) {
      this.productSearchRequest.class2 = '';
      this.productSearchRequest.class3 = '';
      this.productSearchRequest.class4 = '';
    } else if (type === 2) {
      this.productSearchRequest.class3 = '';
      this.productSearchRequest.class4 = '';
    } else if (type === 3) {
      this.productSearchRequest.class4 = '';
    }
  }

  onTherapeuticFilterChanged(type: TherapeuticType): void {
    this.getTherapeutic(type);
    this.resetCategoryFilter(type);
    this.OnFilterSearchChanged.emit(this.productSearchRequest);
  }

  onSelect(event: any): void {
    this.OnFilterSearchChanged.emit(this.productSearchRequest);
  }
}
